import { css, cx } from "@emotion/css";
import { mergeProps } from "react-aria";
import { Select as AriaSelect, SelectProps } from "react-aria-components";

import { sharedStyles } from "../../styles";

export function _Select<T extends object>(props: SelectProps<T>) {
  return (
    <AriaSelect
      {...mergeProps(props, {
        className: cx(sharedStyles.field, styles.select),
      })}
    />
  );
}

const styles = {
  select: css({
    minWidth: "44px",
    "> button": css(sharedStyles.input, {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      minHeight: "40px",

      "> span": css({
        flex: 1,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }),
    }),
    // Hack to hide hidden options - possible bug in react-aria-components that causes an accessibility warning.
    "&[aria-hidden]": { display: "none" },
    "&[data-invalid] > button": {
      boxShadow: `inset 0 0 0 1px var(--border-danger-input)`,
      "&[data-focused]": {
        boxShadow: "var(--focus-input-error)",
      },
    },
  }),
};
